import React, { useState, useEffect } from "react";
import { Waypoint } from "react-waypoint";
import { Link } from "react-router-dom";

// Style
import { Wrapper, Content, MenuImage } from "./GridMenu.styles";

// data Image
import { dataImage } from "./dataGridMenu";
import Spinner from "../../Image/spinner.png";

const GirdMenu = () => {
	const [styleOnScroll, setStyleOnScroll] = useState(false);
	const [onEnter, setOnEnter] = useState(false);

	useEffect(() => {
		if (!onEnter) return;
		setStyleOnScroll(true);
		const timeout = setTimeout(() => setStyleOnScroll(false), 3000);

		return () => {
			clearTimeout(timeout);
		};
	}, [onEnter]);

	return (
		<Waypoint
			onEnter={() => {
				setOnEnter(true);
			}}
			onLeave={() => {
				setOnEnter(false);
				setStyleOnScroll(false);
			}}
		>
			<Wrapper id="brand">
				<h1>Brands</h1>
				{dataImage.length === 0 ? (
					<Content>
						<MenuImage src={Spinner} alt="Spin" />
					</Content>
				) : (
					dataImage.map(image => {
						return (
							<Link to={image.linkTo} key={image.alt}>
								<Content
									key={image.alt}
									styleOnScroll={styleOnScroll}
								>
									<MenuImage
										src={
											process.env.PUBLIC_URL +
											`${image.src}`
										}
										alt={image.alt}
									/>
									{styleOnScroll && (
										<p>Click Here for Menu</p>
									)}
								</Content>
							</Link>
						);
					})
				)}
			</Wrapper>
		</Waypoint>
	);
};

export default GirdMenu;
